<template>
  <v-container>
    <div class="medicine-question-analytics">
      <v-row class="my-2">
        <v-col>
          <h2 class="text-no-wrap">
            くすりぼ：利用・アンケート集計
          </h2>
        </v-col>
        <v-col class="pl-0 d-flex justify-end align-center">
          <div class="picker-align-right">
            <month-picker
              v-model:selectedDate="selectedDate"
              @on-month-changed="saveSelectedDate"
            />
          </div>
        </v-col>
      </v-row>

    <template
      v-if="pregnantUsages && afterChildbirthUsages"
    >
      <div class="mb-5">
        <h4>
          ■利用状況別の利用件数
        </h4>
        <v-row>
          <v-col>
            <v-table class="mt-1 table-striped">
              <tbody class="font-size-10-rem">
                <tr>
                  <td class="text-left w-75">
                    妊娠中
                  </td>
                  <td class="text-left">
                    {{ pregnantUsages.usages }}({{ pregnantUsages.usagesPercent }}%)
                  </td>
                </tr>
                <tr>
                  <td class="text-left w-75">
                    産後
                  </td>
                  <td class="text-left">
                    {{ afterChildbirthUsages.usages }}({{ afterChildbirthUsages.usagesPercent }}%)
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-col>
        </v-row>
      </div>
    </template>

    <template
      v-if="quickSurveys"
    >
      <div class="mb-5">
        <h4>
          ■くすりぼ利用後アンケート／この回答に満足しましたか？
        </h4>
        <v-row>
          <v-col>
            <v-table class="mt-1 table-striped">
              <tbody class="font-size-10-rem">
                <template
                  v-for="survey in quickSurveys"
                  :key="survey.surveyName"
                >
                  <tr>
                    <td class="text-left w-75">
                      {{ survey.surveyName }}
                    </td>
                    <td class="text-left">
                      {{ survey.surveyCount }}({{ survey.surveysPercent }}%)
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-table>
          </v-col>
        </v-row>
      </div>
    </template>

    <template
      v-if="pregnantUsages"
    >
      <div class="mb-5">
        <h4>
          ■妊娠中ーくすりぼ利用内容
        </h4>
        <v-row>
          <v-col>
            <symptom-usages
              :usages-by-symptoms="pregnantUsages.usagesBySymptoms"
            />
          </v-col>
        </v-row>
      </div>
    </template>

    <template
      v-if="afterChildbirthUsages"
    >
      <div class="mb-5">
        <h4>
          ■産後ーくすりぼ利用内容
        </h4>
        <v-row>
          <v-col>
            <symptom-usages
              :usages-by-symptoms="afterChildbirthUsages.usagesBySymptoms"
            />
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from "vue"
import { useStore } from "../stores/index"
import monthPicker from "./shared/MonthPicker.vue"
import symptomUsages from "./shared/SymptomUsages.vue"

export default defineComponent({
  name: "MedicineQuestionAnalyticsPage",
  components: {
    monthPicker,
    symptomUsages
  },
  setup() {
    const store = useStore()

    const pregnantUsages = computed(() => store.getters.medicineQuestionPregnantUsages)
    const afterChildbirthUsages = computed(() => store.getters.medicineQuestionAfterChildbirthUsages)
    const quickSurveys = computed(() => store.getters.medicineQuestionQuickSurveys)

    const selectedDate = computed(() => new Date(store.getters.selectedMedicineQuestionAnalyticsDate))

    const saveSelectedDate = async (selectedValue: Date) => {
      await store.dispatch("commitSelectedMedicineQuestionAnalyticsDate", selectedValue)
    }

    onMounted(() => {
      store.dispatch("commitSelectedMedicineQuestionAnalyticsDate", selectedDate.value)
    })

    return {
      selectedDate,
      saveSelectedDate,
      pregnantUsages,
      afterChildbirthUsages,
      quickSurveys
    }
  },
})
</script>
